<template>
  <v-dialog v-model="visible" width="450">
    <v-card class="cardStyle">
      <v-card-title class="headline lighten-2 titleCard" primary-title>
        <span>
          {{ title }}
        </span>
        <v-icon style="position: absolute; right: 15px" large @click="reject">
          mdi-close
        </v-icon>
      </v-card-title>
      <v-card-text v-html="message" />
      <v-card-actions style="margin-top: 20px">
        <v-col>
          <v-row>
            <v-col>
              <span>{{$t('Collateralmodal.MessagePublish', {percentage:percentage})}} </span>
              <br> <span> {{ $t('CollateralModal.Minimum value to pay') }} {{ minValue }}</span>
              <v-text-field v-model="amount"
                            style="max-width: 150px;margin:auto;" label="Ammount" />
              <span>{{ $t('CollateralModal.Email list notification') }}</span>
              <v-textarea
                v-model="emails"
                label="emails"
                auto-grow
                outlined
                rows="2"
                row-height="10"
              />
            </v-col>
          </v-row>
          <span style="align-self: center"> Pay with Stripe</span>
          <v-row style="justify-content: center">
            <v-col cols="12" style="text-align: center;">
              <PaymentComponent v-if="minValue && factoring.receiver" :amount="minValue"  @success="onSuccess" @cancel="onCancel" />
            </v-col>
          </v-row>
          <span> OR</span>
          <v-row style="justify-content: center">
            <v-col cols="12" style="text-align: center;">
              <v-btn x-large class="btnYes" @click="payWithCrypto">
                Pay with crypto
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Constants from "../../constants";
import ApiRepository from "@/repositories/ApiRepository";
import SmartRepository from "@/repositories/SmartRepository";
import PaymentComponent from "../components/Payment";
import Hash from 'object-hash';
export default {
    name: "CollateralModal",
    components: {PaymentComponent
    },
    data: () => ({
        visible: false,
        title: "Title",
        message: "Message",
        onYes: null,
        onNo: null,
        amount: 0,
        maxAmount: 0,
        factoring: null,
        receiver: null,
        refresh: false,
        stripeActive: false,
        percentage: 0,
        minValue: 0,
        invoiceId: null,
        emails: '',
        platformCommissionm : 0
    }),
    watch: {
    },
    created () {
        this.$root.$on('show-collateral-modal', (event) => {
            this.handleCallbacks(event);
            this.setInformation(event);
            this.show(event);
        });
    },
   
    methods: {
        show () {
            this.visible = true;
        },
        hide () {
            this.visible = false;
        },
        accept () {
            if (this.$data.onYes) {
                this.$data.onYes();
            }
            this.hide();
        },
        reject () {
            if (this.$data.onNo) {
                this.$data.onNo();
            }
            this.hide();
        },
        setInformation (jInfo) {
            this.title = jInfo.title;
            this.message = jInfo.message;
            this.factoringId =  jInfo.factoring;
            ApiRepository.getFactoringById(this.factoringId).then((res) => {
                this.factoring = res.data.factoring;
                this.receiver = res.data.factoring.receiver;
                ApiRepository.getParametersMarket().then((res) => {
                    this.percentage = this.$user._id === this.receiver._id ? res.data.params.percentageInvoiceReceiver : res.data.params.percentageInvoicePayer;
                    this.platformCommission = res.data.params.platformCommision;
                    this.minValue = (this.factoring.formulaCalc.ACclc * this.percentage) / 100;
                    this.amount = this.minValue;
                }).catch((err) => {
                    this.$root.$emit('show-snackbar', {message: this.$t(err.response.data.errorCode), color: "error"});
                    console.log(err);
                });
            }).catch((err) => {
                this.$root.$emit('show-snackbar', {message: this.$t(err.response.data.errorCode), color: "error"});
                console.log(err);
            });
        },
        handleCallbacks (event) {
            if (typeof event.yes === 'function') {
                this.$data.onYes = event.yes;
            }
            if (typeof event.no === 'function') {
                this.$data.onNo = event.no;
            }
        },
        async addInvoice () {
            const mySTR = this.factoring._id.toString();
            const hash = '0x' + Hash.sha1(mySTR);
            const params = await ApiRepository.getParametersMarket();
            const platformCommission = params.data.params.platformCommision  > 0 ? (params.data.params.platformCommision * this.amount) / 100 : 0;
            SmartRepository.transaction(Constants.contractMarketplace, "addInvoice", [this.factoring.receiver.walletAddress, hash, SmartRepository.parseEther(this.amount), SmartRepository.parseEther(platformCommission), SmartRepository.parseEther(this.factoring.formulaCalc.ACclc)])
                .then(() => {
                    this.$root.$emit('stop-loading');
                    this.setMarketItem();
                    this.accept();
                }).catch((e) => {
                    let message = e.toString();
                    if (e.message) {
                        message = e.message;
                    }
                    this.$root.$emit('stop-loading');
                    this.$root.$emit('show-snackbar', {message: message, color: "error"});
                });
        },
        payWithCrypto () {
            if (this.amount < this.minValue) {
                this.$root.$emit('show-snackbar', {message: 'Ammount < min ammount', color: "error"});
            }
            this.$root.$emit('start-loading');
            SmartRepository.call(Constants.contractByto, "allowance", [SmartRepository.getMyAddress(), Constants.contractMarketplace.address])
                .then((res) => {
                    if (res.toString() === '0') {
                        const BN = SmartRepository.getBN();
                        const maxNumber = (BN.from(2)).pow(BN.from(256)).sub(BN.from(1));
                        SmartRepository.transaction(Constants.contractByto, "increaseAllowance", [Constants.contractMarketplace.address, maxNumber])
                            .then(() => {
                                this.addInvoice();
                            }).catch((e) => {
                                let message = e.toString();
                                if (e.message) {
                                    message = e.message;
                                }
                                this.$root.$emit('show-snackbar', {message: message, color: "error"});
                            });
                    } else {
                        this.addInvoice();
                    }
                });
        },
        setMarketItem () {
            ApiRepository.setMarketItem(this.factoring._id, this.$user.name, this.percentage,  this.emails).then((res) => {
                this.$root.$emit('show-snackbar', {message: this.$t('CollateralModal.Add to list'), color: "success"});
                this.accept();
            }).catch((err) => {
                this.$root.$emit('show-snackbar', {message: err.error, color: "error"});
                this.reject();
            });
        },
        async onSuccess () {
            const params = await ApiRepository.getParametersMarket();
            const platformCommission = params.data.params.platformCommision > 0 ? (params.data.params.platformCommision * this.amount) / 100 : 0;
            ApiRepository.addInvoiceMarketItem(this.factoring.receiver.walletAddress, this.factoring._id, this.amount, this.factoring.formulaCalc.ACclc, platformCommission).then((res) => {
                this.$root.$emit('show-snackbar', {message: this.$t('CollateralModal.Add to list'), color: "success"});
                this.accept();
            }).catch((e) => {
                this.$root.$emit('show-snackbar', {message: e.error, color: "error"});
            });
        },
        onCancel () {
            this.$root.$emit('show-snackbar', {message: 'Error payment stripe', color: "error"});
            this.reject();
        }
    },
};
</script>
<style>

</style>
